import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { BsCheckCircleFill } from 'react-icons/bs';
import { shallowEqual, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, TextField } from 'src/components';
import LabelCustomSelect from 'src/components/LabelSelect/LabelCustomSelect';
import SlideInModal from 'src/components/slideInModal';
import useFetch from 'src/hooks/useFetch';
import { fetchItemCategories } from 'src/redux/action/item.action';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';
import EditCategory from './EditCategory';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import Radio from 'src/components/radio';
// import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal?: any;
  showModal?: boolean;
  categoryData?: any;
}

// form validation
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Category name must a at least 3 character long')
    .required('Category Name is required'),
});

const categoryRepresentationPos = [
  {
    id: 0,
    color: '#EF476F',
  },
  {
    id: 1,
    color: '#ECAA00',
  },
  {
    id: 2,
    color: '#187855',
  },
  {
    id: 3,
    color: '#214E6D',
  },
  {
    id: 4,
    color: '#C2212D',
  },
  {
    id: 5,
    color: '#54478C',
  },
];

const AddCategory: React.FC<IProps> = ({
  showModal,
  handleModal,
  categoryData,
}) => {
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  // const [showSquareShape, setShowSquareShape] = React.useState(true);
  // const [showCircleShape, setShowCircleShape] = React.useState(false);
  // const [selectColor, setSelectColor] = React.useState('#EF476F');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { settingData, loading, error } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const services = settingData?.settings?.services ?? [];

  useEffect(() => {
    const checkEditData =
      location?.state === null && categoryData === undefined;
    if (location.pathname === '/edit-category' && checkEditData) {
      navigate('/item-categories');
    }
  });

  const { editCategoryData, editCategoryId, editCategory } =
    location?.state || categoryData;

  const intValues = {
    name: editCategory ? editCategoryData?.categoryInfo?.name : '',
    labels: editCategory ? editCategoryData?.labelInfo?.id : '',
    shape: editCategory ? editCategoryData?.categoryInfo?.shape : 'square',
    color: editCategory ? editCategoryData?.categoryInfo?.color : '#EF476F',
    printType: editCategory ? editCategoryData?.categoryInfo?.printType : 'KOT',
    ischecked: editCategory
      ? editCategoryData?.categoryInfo?.services.map((service: any) =>
          service.isSelected ? true : false
        )
      : Array(services.length).fill(false),
  };

  const { data: labelData } = useFetch('/labels');

  const handleSubmit = async (val: any) => {
    const filteredArray = services
      .filter((_: any, index: number) => val.ischecked[index])
      .map((item: any) => item.id);
    const payload = {
      id: editCategoryId,
      name: val?.name,
      color: val?.color,
      shape: val?.shape,
      labelId: val?.labels,
      serviceIds: filteredArray,
      printType: val?.printType,
    };

    try {
      if (editCategory) {
        await Service.put('/categories/edit', payload);
      } else {
        await Service.post('/categories/create', payload);
      }
      toastAlert(
        'success',
        `${val?.name} category successfully ${
          editCategory ? 'edited' : 'added'
        }`
      );
      dispatch(fetchItemCategories() as any);
      editCategory && navigate('/item-categories');

      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };

  const filterlabel = labelData
    ? labelData?.map((item: any) => {
        return {
          name: item?.name,
          id: item?.id,
        };
      })
    : [];

  const handleCheck = (index: number, values: any, setFieldValue: any) => {
    const ischecked = values.ischecked;
    const checkedArr = [...ischecked];
    checkedArr[index] = !ischecked[index];
    setFieldValue('ischecked', checkedArr);
  };

  const renderSwitch = (
    each: any,
    i: number,
    values: any,
    setFieldValue: any
  ) => (
    <div className="flex justify-between" key={'each.name' + i}>
      <span className="text-black">{each.name}</span>
      <label className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer">
        <div
          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-500 ${
            values.ischecked?.[i] ? 'transform translate-x-full bg-primary' : ''
          }`}
        ></div>
        <input
          type="checkbox"
          className="hidden"
          checked={values.ischecked?.[i]}
          onChange={(e) => handleCheck(i, values, setFieldValue)}
        />
      </label>
    </div>
  );

  const FormComponent = () => (
    <div className="mx-5 mt-4 pb-16">
      {errorMsgPost && (
        <p className="text-warning text-center text-sm font-semibold capitalize">
          {errorMsgPost}
        </p>
      )}
      <Formik
        initialValues={intValues}
        validateOnMount
        validationSchema={FORM_VALIDATION}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid, values, setFieldValue }) => (
          <Form className="mt-5">
            <TextField
              label="Category Name"
              name="name"
              defaultValue={
                editCategoryData ? editCategoryData?.categoryInfo?.name : ''
              }
              // value={intValues.name}
            />
            <Field
              name="labels"
              options={filterlabel}
              className={'mt-3 mb-5'}
              component={LabelCustomSelect}
              isMulti={false}
              label="Assign to label"
              defaultValue={
                editCategory &&
                editCategoryData?.labelInfo && {
                  label: editCategoryData?.labelInfo.name,
                  value: editCategoryData?.labelInfo.id,
                }
              }
            />

            <p className="pt-4 font-semibold text-black">Print Option</p>
            <Radio
              name="printType"
              labelOne="KOT"
              labelTwo="BOT"
              valueOne="KOT"
              valueTwo="BOT"
              selectedValue={
                editCategoryData
                  ? editCategoryData.categoryInfo?.printType
                  : 'KOT'
              }
            />

            <span className="font-semibold text-black">
              Available in Services
            </span>
            <div className="flex flex-col gap-4 my-5">
              {services?.map((each: any, i: number) =>
                renderSwitch(each, i, values, setFieldValue)
              )}
            </div>

            <div className="">
              <h5 className="text-xl font-semibold mb-4 text-black">
                Representation on POS
              </h5>
              <div className="flex items-center space-x-10 mb-10">
                <div
                  onClick={() => {
                    values.shape !== 'square' &&
                      setFieldValue('shape', 'square');
                  }}
                  className={`${
                    values.shape === 'square'
                      ? 'border-primary'
                      : 'border-border-color-dark'
                  }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded`}
                >
                  {values.shape === 'square' && (
                    <BsCheckCircleFill color="#4062FF" />
                  )}
                </div>
                <div
                  onClick={() => {
                    values.shape !== 'circle' &&
                      setFieldValue('shape', 'circle');
                  }}
                  className={`${
                    values.shape === 'circle'
                      ? 'border-primary'
                      : 'border-border-color-dark'
                  }  h-16 w-16 border border-border-color-dark flex items-center justify-center cursor-pointer rounded-full transition-all duration-100`}
                >
                  {values.shape === 'circle' && (
                    <BsCheckCircleFill color="#4062FF" />
                  )}
                </div>
              </div>
              <div className="grid grid-cols-4">
                {categoryRepresentationPos?.map((item) => (
                  <div
                    className={`${
                      values.shape === 'circle' ? 'rounded-full' : 'rounded'
                    } ${
                      item?.color === values.color && 'border-primary border-2'
                    } h-[55px] w-[55px] mb-10 shadow-xl cursor-pointer hover:ease-in-out transform hover:scale-[10px] transition-all duration-100`}
                    key={item?.id}
                    style={{ backgroundColor: `${item?.color}` }}
                    onClick={() => setFieldValue('color', item?.color)}
                  />
                ))}
              </div>
            </div>

            <div className="flex items-center justify-end mt-10">
              <Button
                text={editCategory ? 'edit category' : ' Add Category'}
                variant="primary"
                isSubmitting={isSubmitting}
                isValid={isValid}
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );

  return (
    <>
      {location.pathname !== '/edit-category' && !editCategory ? (
        showModal && (
          <SlideInModal
            showModal={showModal}
            title={editCategory ? 'Edit Category' : 'Add Category'}
            onClick={handleModal}
            className="bg-pure-white z-[9999]"
          >
            <FormComponent />
          </SlideInModal>
        )
      ) : (
        <EditCategory categoryId={editCategoryId}>
          <FormComponent />
        </EditCategory>
      )}
    </>
  );
};

export default React.memo(AddCategory);
